import styled from '@emotion/styled'
import { Tab as MuiTab } from '@mui/material'

export const Tab = styled(MuiTab)`
	align-items: center !important;
`
